import React, { useState } from 'react';
import ButtonOptions from '../../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../../components/NovoSistema/HeaderButtons';
import Alimentacao from './Alimentacao';
import Hospedagem from './Hospedagem';
import PassagemAerea from './PassagemAerea';
import TaxiUberTaxiCorporativo from './TaxiUberTaxiCorporativo';

export default function RacionalDeOutrosGastos() {
  const [option, setOption] = useState('');
  return (
    <main>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Hospedagem"
          border="#4673B2"
          active={option === 'Hospedagem' ? true : false}
          yourFunction={() => setOption('Hospedagem')}
        />
        <ButtonOptions
          buttonName="Passagem Aérea"
          border="#4673B2"
          active={option === 'Passagem Aérea' ? true : false}
          yourFunction={() => setOption('Passagem Aérea')}
        />
        <ButtonOptions
          buttonName="Táxi / Uber / Táxi Corporativo"
          border="#4673B2"
          active={option === 'Táxi / Uber / Táxi Corporativo' ? true : false}
          yourFunction={() => setOption('Táxi / Uber / Táxi Corporativo')}
        />
        <ButtonOptions
          buttonName="Alimentação"
          border="#4673B2"
          active={option === 'Alimentação' ? true : false}
          yourFunction={() => setOption('Alimentação')}
        />
      </HeaderButtons>
      {option === 'Hospedagem' && <Hospedagem />}
      {option === 'Passagem Aérea' && <PassagemAerea />}
      {option === 'Táxi / Uber / Táxi Corporativo' && <TaxiUberTaxiCorporativo />}
      {option === 'Alimentação' && <Alimentacao />}
    </main>
  );
}
